import FacebookIcon from "../assets/images/facebook.png";
import InstagramIcon from "../assets/images/instagram.png";
import DiscordIcon from "../assets/images/discord.png";
import MailIcon from "../assets/icons/mail.svg";
import PhoneIcon from "../assets/icons/phone.svg";
import { featuredArticle } from "../data/featuredArticle";
import "../styles/Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer id="footer" className="footer">
      <div className="footer__main">
        {/* Colonne 1 - Marque + contact */}
        <div className="footer__col">
          <span className="footer__brand">Gucant Informatique</span>
          <ul className="footer__list">
            <li>
              <a
                href="mailto:contactgucant@gmail.com"
                className="footer__contact-link"
              >
                <img src={MailIcon} alt="" className="footer__icon" />
                contactgucant@gmail.com
              </a>
            </li>
            <li>
              <a href="tel:0631546066" className="footer__contact-link">
                <img src={PhoneIcon} alt="" className="footer__icon" />
                06.31.54.60.66
              </a>
            </li>
          </ul>
        </div>

        {/* Colonne 2 - Navigation */}
        <div className="footer__col">
          <h4 className="footer__col-title">Navigation</h4>
          <ul className="footer__list">
            <li>
              <a href="/#home" className="footer__link">
                Accueil
              </a>
            </li>
            <li>
              <a href={featuredArticle.path} className="footer__link">
                Alerte sécurité
              </a>
            </li>
            <li>
              <a href="/#news" className="footer__link">
                Actualités
              </a>
            </li>
            <li>
              <a href="/#about-us" className="footer__link">
                À propos
              </a>
            </li>
            <li>
              <a href="/#services" className="footer__link">
                Services
              </a>
            </li>
            <li>
              <a href="/#reviews" className="footer__link">
                Avis Google
              </a>
            </li>
          </ul>
        </div>

        {/* Colonne 3 - Documents légaux */}
        <div className="footer__col">
          <h4 className="footer__col-title">Documents</h4>
          <ul className="footer__list">
            <li>
              <a
                href="https://api.gucant.fr/doc/CGV - EURL.pdf"
                target="_blank"
                rel="noreferrer"
                className="footer__link"
              >
                Conditions Générales de Vente
              </a>
            </li>
            <li>
              <a
                href="https://api.gucant.fr/doc/RGPD.pdf"
                target="_blank"
                rel="noreferrer"
                className="footer__link"
              >
                Règlementation RGPD
              </a>
            </li>
            <li>
              <a
                href="https://api.gucant.fr/doc/Bon de Prise en Charge.pdf"
                target="_blank"
                rel="noreferrer"
                className="footer__link"
              >
                Conditions de Garantie
              </a>
            </li>
          </ul>
        </div>

        {/* Colonne 4 - Reseaux sociaux */}
        <div className="footer__col">
          <h4 className="footer__col-title">Retrouvez-nous</h4>
          <ul className="footer__list">
            <li>
              <a
                href="https://www.facebook.com/gucantinfo/"
                target="_blank"
                rel="noreferrer"
                className="footer__social-link"
              >
                <img
                  src={FacebookIcon}
                  alt=""
                  className="footer__social-logo"
                />
                Facebook
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/gucantinfo/"
                target="_blank"
                rel="noreferrer"
                className="footer__social-link"
              >
                <img
                  src={InstagramIcon}
                  alt=""
                  className="footer__social-logo"
                />
                Instagram
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/gucantinfo/"
                target="_blank"
                rel="noreferrer"
                className="footer__social-link"
              >
                <img src={DiscordIcon} alt="" className="footer__social-logo" />
                Discord
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer__bottom">
        <p>
          © {year} GUCANT INFORMATIQUE — 3 bis Rue Leuriou, 29300 QUIMPERLE •
          EURL au capital de 1 000 € • SIRET 937 661 155 00013 • APE 9511Z • TVA
          FR64937661155
        </p>
        <p className="footer__bottom-credits">
          Site conçu et réalisé par{" "}
          <a
            href="https://www.linkedin.com/in/jordan-hereng-4267b8185/"
            target="_blank"
            rel="noreferrer"
          >
            Jordan Hereng
          </a>
          , entreprise associée
        </p>
      </div>
    </footer>
  );
};

export default Footer;
